import {
    FORT_BATTLES_START_INTERIM,
    SORTIES_START_INTERIM,
    UNIT_TYPES,
} from 'constants'

export function getPeripheryById(peripheries, peripheryId) {
    return peripheries.find(item => item.periphery_id === peripheryId)
}

/**
 * Returns list of peripheries which are available at this moment (using "interim" setting if suitable)
 * @param {object[]} peripheries -- list of peripheries like in available_units.meta.sorties.peripheries
 * @param {string} unitType -- currently FORT_BATTLE or SORTIES
 * @param {number} interimMs -- interim (in milliseconds) before prime time start when we need to
 * show it like it started.
 *
 * peripheries example:
 * {
 *   battle_modes: ["CHAMPION", "ABSOLUTE"],
 *   name: "WOT RU6",
 *   periphery_id: 106,
 *   primetime_end: 1530226800000,
 *   primetime_start: 1530198000000
 * }
 * */
export function getAvailablePeripheries(peripheries, unitType, interimMs = SORTIES_START_INTERIM) {
    return peripheries.filter(periphery => {
        if (unitType === UNIT_TYPES.SORTIE) return isSortiesAvailable(periphery, interimMs)

        return isFortBattlesAvailable(periphery)
    })
}

export function isSortiesAvailable(periphery, interimMs = SORTIES_START_INTERIM) {
    if (!periphery) return false

    const nowTimestamp = Date.now()
    return (
        periphery.primetime_start - interimMs < nowTimestamp &&
        periphery.primetime_end > nowTimestamp
    )
}

export function checkBattleModeAvailableAtPeriphery(periphery, battleMode) {
    if (!periphery) return false
    return periphery.battle_modes.includes(battleMode)
}

export function isFortBattlesAvailable(periphery) {
    if (!periphery) return false

    const nowTimestamp = Date.now()
    const futureTick = getClosestMatchmakerTick(periphery)

    if (futureTick === undefined) return false

    return futureTick - FORT_BATTLES_START_INTERIM < nowTimestamp
}

export function getClosestMatchmakerTick(periphery) {
    const nowTimestamp = Date.now()
    return periphery.matchmaker_ticks.find(tick => (tick > nowTimestamp))
}

export function getSortiesPeripheriesByClosestPrimetime(peripheries) {
    const nowTimestamp = Date.now()
    return peripheries
        .filter(periphery => periphery.primetime_start > nowTimestamp)
        .sort((a, b) => a.primetime_start - b.primetime_start)
        .filter((periphery, idx, list) => list[0].primetime_start === periphery.primetime_start)
}

export function getBattlesPeripheriesByClosestPrimetime(peripheries) {
    return peripheries
        .filter(periphery => getClosestMatchmakerTick(periphery))
        .sort((a, b) => getClosestMatchmakerTick(a) - getClosestMatchmakerTick(b))
        .filter((periphery, idx, list) => getClosestMatchmakerTick(list[0]) === getClosestMatchmakerTick(periphery))
}

export function getPeripheriesList(availablePeripheries) {
    return availablePeripheries.map(item => item.name).join(', ')
}



// WEBPACK FOOTER //
// ./helpers/peripheries.js